import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Styles/Navbar.css";
import NotebookLogoMark from "./NotebookLogoMark";

function Navbar() {
    const [userName, setUserName] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const cookies = document.cookie.split("; ");
        const userEmailCookie = cookies.find((row) => row.startsWith("userEmail="));
        if (userEmailCookie) {
            const email = userEmailCookie.split("=")[1].trim().toLowerCase();
            fetch(`https://dalhousiecombatroboticsteam.onrender.com/get-user?email=${email}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.name) {
                        setUserName(data.name.split(" ")[0]);
                    }
                })
                .catch((err) => {
                    console.error("Failed to fetch user name:", err);
                });
            fetch(`https://dalhousiecombatroboticsteam.onrender.com/check-admin?email=${email}`)
                .then((res) => res.json())
                .then((adminData) => {
                    if (adminData.isAdmin) {
                        setIsAdmin(true);
                    }
                })
                .catch((err) => console.error("Failed to check admin:", err));
        }
    }, []);

    const closeMenu = () => setMenuOpen(false);
    const navLinkClass = ({ isActive }) => `nav-button${isActive ? " nav-button--active" : ""}`;

    return (
        <header className="navbar">
            <div className="navbar-inner">
                <div className="navbar-brand">
                    <Link
                        to="/"
                        className="logo"
                        onClick={closeMenu}
                        aria-label="Dalhousie Combat Robotics Team home"
                    >
                        <NotebookLogoMark variant="nav" />
                    </Link>
                    <span className="navbar-tagline" aria-hidden="true">
                        DCRT
                    </span>
                </div>

                <button
                    type="button"
                    className={`navbar-toggle ${menuOpen ? "is-open" : ""}`}
                    onClick={() => setMenuOpen((o) => !o)}
                    aria-expanded={menuOpen}
                    aria-controls="primary-navigation"
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                >
                    <span className="navbar-toggle-bar" />
                    <span className="navbar-toggle-bar" />
                    <span className="navbar-toggle-bar" />
                </button>

                <nav id="primary-navigation" className={`nav-links ${menuOpen ? "is-open" : ""}`}>
                    <NavLink to="/" end className={navLinkClass} onClick={closeMenu}>
                        Home
                    </NavLink>
                    <NavLink to="/Timeline" className={navLinkClass} onClick={closeMenu}>
                        Timeline
                    </NavLink>
                    {!userName && (
                        <NavLink to="/GetInvolved" className={navLinkClass} onClick={closeMenu}>
                            Get involved
                        </NavLink>
                    )}
                    <NavLink to="/blogs" className={navLinkClass} onClick={closeMenu}>
                        Blog
                    </NavLink>
                    <NavLink to="/Sponsors" className={navLinkClass} onClick={closeMenu}>
                        Sponsors
                    </NavLink>
                    {isAdmin && (
                        <NavLink to="/addblog" className={navLinkClass} onClick={closeMenu}>
                            Add blog
                        </NavLink>
                    )}
                    {userName && (
                        <div className="nav-user">
                            <span className="nav-user-greeting">
                                <span className="nav-user-label">Operator</span>
                                <span className="nav-user-name">{userName}</span>
                            </span>
                            <button
                                type="button"
                                className="nav-logout-btn"
                                onClick={() => {
                                    document.cookie = "userEmail=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                                    window.location.reload();
                                }}
                            >
                                Log out
                            </button>
                        </div>
                    )}
                </nav>
            </div>
            <div className="navbar-scanline" aria-hidden="true" />
        </header>
    );
}

export default Navbar;
